import { render, staticRenderFns } from "./MealList.vue?vue&type=template&id=64e233d7&scoped=true&"
import script from "./MealList.vue?vue&type=script&lang=js&"
export * from "./MealList.vue?vue&type=script&lang=js&"
import style0 from "./MealList.scss?vue&type=style&index=0&id=64e233d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e233d7",
  null
  
)

export default component.exports